import React from 'react';

/**
 * Brand-safe export marks: generic sport / navigation shapes with palette hints only
 * (no third-party logos or wordmarks).
 */

const GARMIN_NAVY = '#1e3a8a';
const POLAR_RED = '#e2001a';
const TP_SEA_1 = '#0f766e';
const TP_SEA_2 = '#14b8a6';
const TP_SEA_3 = '#0d9488';

/** Garmin-style cue: navigation arrow in navy (GPS / outdoor navigation). */
export function GarminMark({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden>
      <path fill={GARMIN_NAVY} d="M12 3 19 13h-4v8H9v-8H5l7-10z" />
    </svg>
  );
}

/** TrainingPeaks-style cue: three mountain peaks in sea / teal tones only. */
export function TrainingPeaksMark({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 32 22" aria-hidden>
      <path fill={TP_SEA_1} d="M0 22 6.5 9 13 22H0z" />
      <path fill={TP_SEA_2} d="M8 22 16 4 24 22H8z" />
      <path fill={TP_SEA_3} d="M19 22 25.5 11 32 22H19z" />
    </svg>
  );
}

/** Polar-style cue: pulse / heart-rate trace inside a circle (no wordmark). */
export function PolarFlowMark({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden>
      <circle cx="12" cy="12" r="10" fill="none" stroke={POLAR_RED} strokeWidth="2" />
      <path
        fill="none"
        stroke={POLAR_RED}
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.5 12.2h2.2l1.4-3.5 2.8 7.1 2.1-8.4 1.6 4.8H18.5"
      />
    </svg>
  );
}
